<cache-date></cache-date>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<br>
<hr>

<section>
	<form>
		<div class="form-check" *ngFor="let radio of ['datePaid', 'dateCreated']">
			<input
					class="form-check-input"
					type="radio"
					id="radio_reportDateType_{{radio}}"
					[(ngModel)]="filter.filterParams.reportDateType"
					[ngModelOptions]="{standalone: true}"
					[value]="radio" [checked]="filter.filterParams.reportDateType == radio"
					(change)="reportDateTypeChange()"
			>
			<label class="form-check-label" for="radio_reportDateType_{{radio}}">{{ 'adminstat.filterForm.' + radio | translate }}</label>
		</div>
	</form>
</section>

<br />

<div class="btn-group" role="group">
	<ng-container *ngFor="let value of ['absolute', 'relative']">
		<button type="button" [class]="paidAliveChartValue == value ? 'btn btn-light active' : 'btn btn-light'" (click)="changePaidAliveChartValue(value)">
			{{ value }}
		</button>
	</ng-container>
</div>
<chart [data]="paidAliveChartData.data" [options]="paidAliveChartData.options"></chart>

<hr><br>


<chart [data]="deathSitesChartData.data" [options]="deathSitesChartData.options"></chart>
<hr><br>

<ngb-accordion #acc="ngbAccordion">
	<ngb-panel title="{{ 'adminstat.billing.expired_paid.By fallen' | translate }}">
		<ng-template ngbPanelContent>
			<loading [isLoad]="fallenLoader"></loading>
			<ng-container *ngIf="!fallenLoader && monthsList.length > 0">
				<h4>{{ 'adminstat.billing.expired_paid.more columns info' | translate }}</h4>

				<table class="table table-bordered table-striped">
					<thead>
					<tr>
						<th>{{ 'adminstat.common.Date' | translate }}</th>

						<ng-container *ngFor="let field of settings | keys">
							<th *ngIf="!settings[field].isHidden" [attr.colspan]="field == 'paid' ? 2 : 1">
								{{ settings[field].i18n | translate }}
							</th>
						</ng-container>
					</tr>
					</thead>

					<tbody>
					<ng-container *ngFor="let month of months">
						<tr
								*ngFor="let period of ['total', 'month', '3months', '6months', '12months', '24months', 'gt24months']"
								[class]="period == 'total' ? 'table-success' : ''"
								[style.display]="(period == 'total' || month.opened) ? 'table-row' : 'none'"
								(click)="showTableRow(month, period)"
						>
							<td>
								{{ period == 'total' ? month.month : '' }}
							</td>

							<td>
								{{ period }}
							</td>

							<ng-container
									*ngFor="let key of ['paid', 'off', 'paidAlive', 'disabled', 'waitForPaid', 'recurrent', 'recurrentOff', 'manualPaid', 'strange']"
							>
								<td
										*ngIf="!settings[key].isHidden"
										class="text-nowrap"
								>
									<button
											type="button"
											class="btn btn-link"
											(click)="showRowDetails(month.data[key][period]?.siteIds, month.month)"
									>
										{{ month.data[key][period]?.count || 0 }}
									</button>

									<span *ngIf="key == 'disabled' || key == 'off'">
											({{ helper.percentageFormat((month.data[key][period]?.count || 0) / (month.data['paid'][period]?.count || 0)) }})
										</span>
								</td>
							</ng-container>
						</tr>
					</ng-container>
					</tbody>
				</table>
			</ng-container>
		</ng-template>
	</ngb-panel>
</ngb-accordion>

<br>
<div class="btn-group" role="group">
	<ng-container *ngFor="let period of ['total', 'month', '3months', '6months', '12months', '24months', 'gt24months']">
		<button type="button" [class]="expiredChartPeriod == period ? 'btn btn-light active' : 'btn btn-light'" (click)="changeExpiredChartPeriod(period)">
			{{ period }}
		</button>
	</ng-container>
</div>

<div class="btn-group" role="group">
	<ng-container *ngFor="let value of ['absolute', 'relative']">
		<button type="button" [class]="expiredChartValue == value ? 'btn btn-light active' : 'btn btn-light'" (click)="changeExpiredChartValue(value)">
			{{ value }}
		</button>
	</ng-container>
</div>
<chart [data]="expiredChartData.data" [options]="expiredChartData.options"></chart>
<loading_percent [percent]="expiredChartPercentLoader"></loading_percent>
<hr><br>


<chart [data]="cumLtvChartData.data" [options]="cumLtvChartData.options"></chart>
<hr><br>

<loading [isLoad]="paidsByMonthsLoader"></loading>
<div *ngIf="!paidsByMonthsLoader && paidByMonthData">
	<h4>
		{{ 'adminstat.common.paidCount' | translate }} : {{ paidByMonthData.paidCount }}
	</h4>

	<h4>
		{{ 'adminstat.common.siteCount' | translate }} : {{ paidByMonthData.siteCount }}
	</h4>

	<ngb-accordion #acc="ngbAccordion">
		<ngb-panel title="{{ 'adminstat.billing.expired_paid.by months' | translate }}">
			<ng-template ngbPanelContent>
				<span style="display: inline-block; width: 15px; height: 15px; background-color: #428bca;"></span> {{ 'adminstat.billing.expired_paid.extended from first payment' | translate }} ,
				<span style="display: inline-block; width: 15px; height: 15px; background-color: #8001FF;"></span> {{ 'adminstat.billing.expired_paid.no monthly payments' | translate }}

				<table class="table">
					<thead>
					<tr>
						<th></th>
						<th *ngFor="let date of paidByMonthData.dateXList">
							{{ moment(date).tz('Europe/Moscow').format('01.MM.YYYY') }}
						</th>
					</tr>
					</thead>

					<tbody>
					<tr *ngFor="let day of paidByMonthData.stats">
						<td>
							{{ moment(day.dateY).tz('Europe/Moscow').format('01.MM.YYYY') }}
						</td>

						<td *ngFor="let _day of day.dates;">
							<ng-container *ngIf="_day.totalSite > 0">
								<div class="text-nowrap">
									<button style="color:#428bca;" type="button" class="btn btn-link" (click)="showRowDetails(_day.firstPaid.siteList, moment(day.dateY).tz('Europe/Moscow').format('01.MM.YYYY'))">
										{{ _day.firstPaid.siteCount }}
									</button>
									+
									<button style="color:#8001FF;" type="button" class="btn btn-link" (click)="showRowDetails(_day.crossPaid.siteList, moment(day.dateY).tz('Europe/Moscow').format('01.MM.YYYY'))">
										{{ _day.crossPaid.siteCount }}
									</button>
								</div>

								<ng-container *ngIf="_day.percent">
									= {{ _day.totalSite }} ({{ helper.percentageFormat(_day.percent) }})
								</ng-container>
							</ng-container>
						</td>
					</tr>
					</tbody>
				</table>
			</ng-template>
		</ngb-panel>
	</ngb-accordion>
</div>
<hr>



<loading [isLoad]="paidsByNumLoader"></loading>
<div *ngIf="!paidsByNumLoader && paidByNumData">
	<ngb-accordion #acc="ngbAccordion">
		<ngb-panel title="{{ 'adminstat.billing.expired_paid.By number of payments' | translate }}">
			<ng-template ngbPanelContent>
				<table class="table">
					<thead>
					<th></th>
					<ng-template ngFor let-item [ngForOf]="createRange(paidByNumData.maxCount)" let-currentElementIndex="index+1">
						<th>{{ currentElementIndex }}</th>
					</ng-template>
					</thead>

					<tbody>
					<tr *ngFor="let stat of paidByNumData.stats; let i = index">
						<td>
							{{ moment(stat.date).tz('Europe/Moscow').format('01.MM.YYYY') }}
						</td>

						<td *ngFor="let numberPayment of stat.numberPaymentList;">
							<button *ngIf="numberPayment.count" type="button" class="btn btn-link" (click)="showRowDetails(numberPayment.siteList, moment(stat.date).tz('Europe/Moscow').format('01.MM.YYYY'))">
								{{ numberPayment.count }}
							</button>

							<span *ngIf="numberPayment.prevPercent">({{ helper.percentageFormat(numberPayment.prevPercent) }})</span>

							<span style="color: #009800;" *ngIf="numberPayment.firstPercent">({{ helper.percentageFormat(numberPayment.firstPercent) }})</span>
						</td>
					</tr>
					</tbody>
				</table>
			</ng-template>
		</ngb-panel>
	</ngb-accordion>
</div>


<br><br>
